import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { Compensations } from '../models/compensations.model';
import { CarApi } from './car-api.base';

@Injectable()
export class CompensationsService extends CarApi<Compensations> {
  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    super('compensations', http, roleService, uxService);
  }
}
